Avatar.theme = Avatar.theme || {};

Avatar.theme.rte = function rte() {
  var selectors = {
    tables: '.rte table',
    iframes: '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
  };
  var classes = {
    tableWrapper: 'tw-scrollable-wrapper',
    iframeWrapper: 'tw-video-wrapper'
  };

  function wrapTable(options) {
    if (!options.tables) return;
    options.tables.forEach(function (table) {
      var wrapper = document.createElement('div');
      wrapper.classList.add(options.tableWrapperClass);
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  function wrapIframe(options) {
    options.iframes.forEach(function (iframe) {
      if (iframe.closest(".".concat(classes.iframeWrapper))) return;
      var wrapper = document.createElement('div');
      wrapper.classList.add(options.iframeWrapperClass);
      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe); // eslint-disable-next-line no-param-reassign, no-self-assign

      iframe.src = iframe.src;
    });
  }

  wrapTable({
    tables: document.querySelectorAll(selectors.tables),
    tableWrapperClass: classes.tableWrapper
  });
  wrapIframe({
    iframes: document.querySelectorAll(selectors.iframes),
    iframeWrapperClass: classes.iframeWrapper
  });
  return {
    wrapTable: wrapTable,
    wrapIframe: wrapIframe,
    iframeSelectors: selectors.iframes
  };
}();